export default __webpack_public_path__ + "static/media/34.c547701c.jpg";